import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import * as userActions from '../../actions/userActions';
import UserForm from './UserForm';
import { Row, Col } from 'reactstrap';
import { toast } from 'react-toastify';

class ManageUserPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: Object.assign({}, props.user),
      errors: {},
      saving: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.user) {
      if (this.props.user.id !== nextProps.user.id) {
        this.setState({ user: Object.assign({}, nextProps.user) });
      }
    }
  }

  redirectSuccess(msg) {
    this.setState({ saving: false });
    toast.success(msg);
    this.props.history.push('/users');
  }

  formIsValid() {
    const { user } = this.state;
    let errors = {};
    let isValid = true;

    if (user.email.length === '') {
      errors.email = 'Please enter a valid email';
      isValid = false;
    }
    if (user.username.length === '') {
      errors.username = 'Enter a valid username';
      isValid = false;
    }
    if (user.initials.length < 2) {
      errors.initials = 'Enter user initials';
      isValid = false;
    }

    this.setState({ errors: errors });
    return isValid;
  }

  saveUser = (event) => {
    event.preventDefault();
    let user = Object.assign({}, this.state.user);
    user.payRate = user.payRate === 'N/A' ? null : parseFloat(user.payRate);
    if (!this.formIsValid()) return;
    this.setState({ saving: true });
    this.props.actions
      .saveUser(this.state.user)
      .then(() => this.redirectSuccess('User saved'))
      .catch((error) => {
        toast.error(error);
        this.setState({ saving: false });
      });
  };

  deleteUser = (event) => {
    event.preventDefault();
    this.setState({ saving: true });
    this.props.actions
      .deleteUser(this.state.user)
      .then(() => this.redirectSuccess('User deleted'))
      .catch((error) => {
        toast.error(error);
        this.setState({ saving: false });
      });
  };

  updateUserState = (event) => {
    const field = event.target.id;
    let user = Object.assign({}, this.state.user);
    user[field] = event.target.value;
    this.setState({ user: user });
  };

  updateResetOption = () => {
    let user = Object.assign({}, this.state.user);
    user.resetRequired = !user.resetRequired;
    this.setState({
      user: user,
    });
  };

  updateActiveOption = () => {
    let user = Object.assign({}, this.state.user);
    user.active = !user.resetRequired;
    this.setState({
      user: user,
    });
  };

  render() {
    return (
      <div>
        <Row>
          <Col md={12}>
            <h1 className="text-center my-4">Manage User</h1>
          </Col>
        </Row>
        <UserForm
          user={this.state.user}
          saving={this.state.saving}
          onChange={this.updateUserState}
          errors={this.state.errors}
          onSave={this.saveUser}
          onActiveChange={this.updateActiveOption}
          onResetChange={this.updateResetOption}
        />
      </div>
    );
  }
}

ManageUserPage.propTypes = {
  user: PropTypes.object,
};

function getUserById(users, id) {
  const user = users.filter((user) => user.id === id);
  if (user) return user[0];
  return null;
}

function mapStateToProps(state, ownProps) {
  const id = ownProps.match.params.id;
  const userId = Number.parseInt(id, 10);

  let user = {
    id: '',
    userId: '',
    userName: '',
    userState: '',
    userType: '',
    active: '',
  };

  if (userId && state.users.length > 0) {
    user = getUserById(state.users, userId);
  }

  return {
    user: user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(userActions, dispatch),
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ManageUserPage)
);



// WEBPACK FOOTER //
// ./src/components/user/ManagerUserPage.js